import React from "react";
import css from './linkButton.module.scss';

export const LinkButton = ({children, onClick}) => { 
  return (
    <button
      type="button"
      className={css.headerlink}
      onClick={onClick}
    >
      {children}
    </button>
  );
};